import React from 'react';
import { useLocation } from 'react-router-dom';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../../context/ThemeContext';
import './ThemeToggle.css';

export default function ThemeToggle() {
  const { theme, toggleTheme } = useTheme();
  const location = useLocation();
  const dashboardClass = location.pathname.startsWith('/dashboard') ? ' theme-toggle--dashboard' : '';
  const isDark = theme === 'dark';

  return (
    <button
      type="button"
      className={`theme-toggle${dashboardClass}`}
      onClick={toggleTheme}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
    >
      <span className={`theme-toggle-track${isDark ? ' is-dark' : ''}`}>
        <FiSun className="theme-toggle-icon theme-toggle-icon--sun" aria-hidden="true" />
        <FiMoon className="theme-toggle-icon theme-toggle-icon--moon" aria-hidden="true" />
        <span className="theme-toggle-knob" aria-hidden="true" />
      </span>
    </button>
  );
}
